export class OrangeObject {

  merchantid: string;
  amount: string;
  sessionid: string;
  purchaseref: string;
  token: string;

}
